import React, { useState } from "react";

export default function BecomeMerchantPage() {
  const [form, setForm] = useState({ name: "", shop_name: "", email: "", phone: "", location: "", message: "" });
  const [photo, setPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) { setPhoto(file); setPhotoPreview(URL.createObjectURL(file)); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData();
      Object.keys(form).forEach(k => formData.append(k, form[k]));
      if (photo) formData.append("photo", photo);
      await fetch("https://comoticket-production.up.railway.app/api/public/merchant-request", {
        method: "POST",
        body: formData,
      });
      setSubmitted(true);
    } catch (err) {
      alert("Erreur lors de l'envoi, veuillez ressayer");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{minHeight:"100vh",background:"#0a0a0a",fontFamily:"'Inter',Arial,sans-serif",color:"white"}}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        .form-input { width: 100%; padding: 14px 16px; background: rgba(255,255,255,0.05); border: 1.5px solid rgba(255,255,255,0.1); border-radius: 12px; color: white; font-size: 14px; font-family: inherit; outline: none; transition: border-color 0.2s; }
        .form-input:focus { border-color: #2563eb; background: rgba(37,99,235,0.05); }
        .form-input::placeholder { color: rgba(255,255,255,0.25); }
      `}</style>

      <nav style={{position:"sticky",top:0,zIndex:100,background:"rgba(10,10,10,0.95)",backdropFilter:"blur(20px)",borderBottom:"1px solid rgba(255,255,255,0.06)",padding:"16px 40px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <a href="/events" style={{display:"flex",alignItems:"center",gap:10,textDecoration:"none"}}>
          <div style={{width:36,height:36,background:"#2563eb",borderRadius:10,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,fontWeight:800,color:"white"}}>C</div>
          <span style={{fontSize:18,fontWeight:800,letterSpacing:"-0.5px",color:"white"}}>ComoTicket</span>
        </a>
        <a href="/revendeurs" style={{color:"rgba(255,255,255,0.5)",fontSize:13,textDecoration:"none"}}>Voir les revendeurs</a>
      </nav>

      <div style={{maxWidth:600,margin:"0 auto",padding:"60px 40px"}}>
        <a href="/revendeurs" style={{color:"rgba(255,255,255,0.4)",fontSize:13,textDecoration:"none",display:"inline-block",marginBottom:24}}>&larr; Retour aux revendeurs</a>

        {submitted ? (
          <div style={{textAlign:"center",padding:"60px 0"}}>
            <div style={{width:72,height:72,background:"rgba(37,99,235,0.15)",borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 20px",fontSize:32,border:"2px solid #2563eb"}}>&#10003;</div>
            <h2 style={{fontSize:24,fontWeight:800,marginBottom:12}}>Demande envoy&eacute;e !</h2>
            <p style={{color:"rgba(255,255,255,0.5)",fontSize:14,lineHeight:1.6}}>Notre &eacute;quipe va &eacute;tudier votre demande et vous contactera pour cr&eacute;er votre espace commer&ccedil;ant.</p>
            <a href="/revendeurs" style={{display:"inline-block",marginTop:24,background:"#2563eb",color:"white",padding:"12px 28px",borderRadius:100,fontWeight:700,fontSize:14,textDecoration:"none"}}>Voir les revendeurs</a>
          </div>
        ) : (
          <>
            <div style={{display:"inline-block",background:"rgba(37,99,235,0.15)",color:"#60a5fa",padding:"6px 14px",borderRadius:100,fontSize:12,fontWeight:700,marginBottom:20,border:"1px solid rgba(37,99,235,0.3)"}}>
              Devenir revendeur
            </div>
            <h1 style={{fontSize:34,fontWeight:900,letterSpacing:"-1.5px",marginBottom:12}}>Rejoignez notre r&eacute;seau de revendeurs</h1>
            <p style={{fontSize:14,color:"rgba(255,255,255,0.5)",marginBottom:32,lineHeight:1.6}}>
              Remplissez ce formulaire et notre &eacute;quipe vous contactera pour cr&eacute;er votre espace commer&ccedil;ant apr&egrave;s validation de votre demande.
            </p>

            <form onSubmit={handleSubmit}>
              <div style={{marginBottom:18}}>
                <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Photo de votre commerce</label>
                <div style={{border:"2px dashed rgba(255,255,255,0.15)",borderRadius:12,padding:20,textAlign:"center",cursor:"pointer",background:"rgba(255,255,255,0.03)"}} onClick={() => document.getElementById("photoInput").click()}>
                  {photoPreview ? (
                    <img src={photoPreview} alt="preview" style={{width:"100%",height:140,objectFit:"cover",borderRadius:8}} />
                  ) : (
                    <div>
                      <div style={{fontSize:28,marginBottom:8}}>&#128247;</div>
                      <div style={{fontSize:13,color:"rgba(255,255,255,0.4)"}}>Cliquer pour ajouter une photo de votre boutique</div>
                    </div>
                  )}
                </div>
                <input id="photoInput" type="file" accept="image/*" style={{display:"none"}} onChange={handlePhotoChange} />
              </div>
              <div style={{marginBottom:18}}>
                <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Votre nom complet *</label>
                <input className="form-input" placeholder="Mohamed Ali" value={form.name} onChange={e => setForm({...form,name:e.target.value})} required />
              </div>
              <div style={{marginBottom:18}}>
                <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Nom du magasin / commerce</label>
                <input className="form-input" placeholder="Boutique Ali - Moroni" value={form.shop_name} onChange={e => setForm({...form,shop_name:e.target.value})} />
              </div>
              <div style={{marginBottom:18}}>
                <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Email *</label>
                <input type="email" className="form-input" placeholder="vous@email.com" value={form.email} onChange={e => setForm({...form,email:e.target.value})} required />
              </div>
              <div style={{marginBottom:18}}>
                <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>T&eacute;l&eacute;phone *</label>
                <input className="form-input" placeholder="+269 321 0000" value={form.phone} onChange={e => setForm({...form,phone:e.target.value})} required />
              </div>
              <div style={{marginBottom:18}}>
                <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Localisation du commerce</label>
                <input className="form-input" placeholder="Moroni, Mitsamiouli..." value={form.location} onChange={e => setForm({...form,location:e.target.value})} />
              </div>
              <div style={{marginBottom:28}}>
                <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Message (optionnel)</label>
                <textarea className="form-input" placeholder="Parlez-nous de votre commerce..." rows={4} value={form.message} onChange={e => setForm({...form,message:e.target.value})} style={{resize:"vertical"}} />
              </div>
              <button type="submit" disabled={loading} style={{width:"100%",background:"#2563eb",border:"none",color:"white",padding:"14px",borderRadius:12,fontWeight:700,fontSize:15,cursor:"pointer",opacity:loading?0.7:1}}>
                {loading ? "Envoi en cours..." : "Envoyer ma demande"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}